/**
 * @param {*} value
 * @returns {number}
 */
function roundDown (value) {
  if (!value) return 0

  let val = value
    .toString()
    .replace(/[^0-9,.]+/g, '')
    .replace(',', '.')

  val = parseFloat(val)

  return Math.floor(val) || 0
}

module.exports = { roundDown }
